var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-title makemebold"},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.makeMyLastWordBold(_vm.pageTitle))}}),_vm._v(" "),(!_vm.removeHrLine)?_c('hr'):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }